export type SupportedCurrency = 'GBP' | 'EUR' | 'USD';

export const SUPPORTED_CURRENCIES: readonly SupportedCurrency[] = ['GBP', 'EUR', 'USD'];

/** Type guard: only GBP/EUR/USD are valid app currencies. */
export function isSupportedCurrency(value: unknown): value is SupportedCurrency {
  return typeof value === 'string' && (SUPPORTED_CURRENCIES as readonly string[]).includes(value);
}

export const CURRENCY_SYMBOL: Record<SupportedCurrency, string> = {
  GBP: '£',
  EUR: '€',
  USD: '$',
};


/** Yearly price display per currency; actual Stripe prices come from stripe_prices. */
export const YEARLY_PRICE_DISPLAY: Record<SupportedCurrency, { amount: number; label: string }> = {
  GBP: { amount: 27, label: '£27/year' },
  EUR: { amount: 32, label: '€32/year' },
  USD: { amount: 36, label: '$36/year' },
};

export function detectCurrencyFromBrowser(): SupportedCurrency {
  // Best-effort; default GBP if unknown
  try {
    const lang = (navigator.language || '').toLowerCase();
    if (lang.includes('gb') || lang.includes('uk') || lang.includes('en-gb')) return 'GBP';
    if (lang.includes('us') || lang.includes('en-us')) return 'USD';
    // Treat most EU locales as EUR
    const eurHints = ['de','fr','es','it','pt','nl','be','ie','fi','at','gr','sk','si','lv','lt','lu','ee','cy','mt'];
    if (eurHints.some(h => lang.includes(h))) return 'EUR';
  } catch {}
  return 'GBP';
}

/**
 * formatMoney(12.99, 'GBP') -> "£12.99"
 * formatMoney(12, 'GBP') -> "£12.00"
 * Always shows 2 decimal places for consistency.
 */
export function formatMoney(amount: number, currency: SupportedCurrency): string {
  return `${CURRENCY_SYMBOL[currency]}${amount.toFixed(2)}`;
}